
export default {
  name: "BenefitCard",

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    icons: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isAnimate: {
      type: Boolean,
      default: false,
    },
    cardIndex: {
      type: Number,
      default: -1,
    },
  },

  computed: {
    icon: function () {
      return this.icons?.[this.item.icon] || null
    },
    benefitCardPersonalAnimation: function () {
      let className = '';
      if (this.isAnimate && this.cardIndex === 0) {
        className = '--animate-benefit-card-first';
      }
      if (this.isAnimate && this.cardIndex === 1) {
        className = '--animate-benefit-card-second';
      }
      if (this.isAnimate && this.cardIndex === 2) {
        className = '--animate-benefit-card-third';
      }
      if (this.isAnimate && this.cardIndex === 3) {
        className = '--animate-benefit-card-fourth';
      }
      if (this.isAnimate && this.cardIndex === 4) {
        className = '--animate-benefit-card-fifth';
      }
      if (this.isAnimate && this.cardIndex === 5) {
        className = '--animate-benefit-card-sixth';
      }
      return className;
    },
  },
}
